module.exports = __webpack_public_path__ + "static/img/7-04.cf72dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/7-04.png
// module id = X0v9
// module chunks = 1